import * as React from 'react';
import Typography from "@material-ui/core/Typography/Typography";
import {makeStyles} from "@material-ui/core/styles/index";
import {serverRootUrl} from "../../config";
import clsx from 'clsx';
import Grid from "@material-ui/core/es/Grid/Grid";
import {ListItem} from "./ListItem";
import Responsive from "../Responsive/Responsive";
import WarmUp from "../Ads/WarmUp/WarmUp";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    grid: {
        width: '100%',
        margin: 0,
    },

}));

export function ListItems(props) {

    const classes = useStyles();

    const items = props.items;
    const filter = props.filter;
    const isMobile = props.isMobile;
    const titleLength = 135;


    let span = null;
    let cellW = null;
    let cellH = null;
    let cells = 3;

    switch (props.size) {
        case 'xxxl':
            span = 4;
            cellW = 300;
            cellH = 225;
            cells = 3;
            break;
        case 'xxl':
            span = 6;
            cellW = 400;
            cellH = 300;
            cells = 2;
            break;
        case 'xl':
            span = 6;
            cellW = 300;
            cellH = 225;
            cells = 2;
            break;
        case 'l':
            span = 12;
            cellW = 400;
            cellH = 300;
            cells = 1;
            break;
        case 'mxxx':
            span = 12;
            cellW = 400;
            cellH = 300;
            cells = 1;
            break;
        case 'mxx':
            span = 12;
            cellW = 300;
            cellH = 225;
            cells = 1;
            break;
        default:
            span = 12;
            cellW = 300;
            cellH = 225;
            cells = 1;
            break;

    }

    const contRef = React.createRef();

    const [cW, setCW] = React.useState();


    //const cW = contRef.current ? contRef.current.clientWidth / 3 : 0;
    //const cH = cW / 1.3333;

    const onChange = (e) => {
        const padding = 10;
        const wrapper = document.getElementById('mainWrapper');
        if (!wrapper) {
            return;
        }
        const width = wrapper.clientWidth - (isMobile ? 0 : 300);
        console.log('width', width, isMobile, 'cells', cells, 'total', items ? items.length : null)
        let newCW = contRef.current
            ? parseInt((width / cells) - padding) : 0;
        if (!newCW) {
            return;
        }
        if (props.size === 'l') {
            newCW = 375;
        }
        if (cW !== newCW) {
            console.log(cW, newCW);
            setCW(newCW);
        }
    };

    const cH = parseInt(cW/1.33333);

    React.useEffect(() => {
        if (contRef.current) {
            onChange();
        }
    });

    return <div className={classes.root} ref={contRef}>
        {cW ? <>
            <Responsive onChange={onChange}/>
            {/*<div style={{
                backgroundColor: 'blue',
                width: cW,
                height: cH,
            }}><br/></div>*/}

            <Grid container spacing={3} className={classes.grid}>
            {items.map((item, index) => {
                 return <>
                     <ListItem item={item} isMobile={isMobile} index={index} size={props.size}
                    span={span} cellW={cW} cellH={cH} returnRoute={props.returnRoute} handleClick={props.handleClick}/>
                 </>;

            })}</Grid>
            </> : null}
            </div>
}